/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : LrAsAnchorLegalRequirementCardTemplate.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box, Card, CardContent, CardHeader, Typography } from "@mui/material";
import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  vlcCardStyles,
  vlcComponentStyle,
} from "../../../components/customComponentsV2/vlc/config/vlcConfig";
import VlcCardContent from "../../../components/customComponentsV2/vlc/cards/VlcCardContent";
import CustomToolTip from "../../../components/infoButton/CustomToolTip";
import CustomPaginationV2 from "../../../components/customComponentsV2/common/pagination/CustomPaginationV2";
import LrAsAnchorLegalRequirementCardHeader from "./LrAsAnchorLegalRequirementCardHeader";
import { componentStyle } from "../../../config/appTheme";

function LrAsAnchorLegalRequirementCardTemplate({
  setCardOpen,
  contentHeight,
  getSelectedLrDetails,
}) {
  const [lrList, setLrList] = useState([]);
  const [lrTotalCount, setLrTotalCount] = useState(0);
  const [lrPage, setLrPage] = useState(1);
  const [lrRowsPerPage] = useState(25);

  const [selectedLrId, setSelectedLrId] = useState(null);
  const [selectedLrObject, setSelectedLrObject] = useState(null);

  //   functions
  const getLRListForSelectedChapter = (lrDetails, totalCount) => {
    console.log("---getLRListForSelectedChapter---", lrDetails);
    setLrList(
      lrDetails.map((lr) => {
        return {
          ...lr,
          cardDataArray: [
            {
              key: "Number",
              keyStyle: {
                fontWeight: 600,
              },
              value: lr.req_number,
            },
            {
              key: "Description",
              value: lr.description,
            },
          ],
        };
      }),
    );
    setLrTotalCount(totalCount);
    if (lrDetails.length) {
      setSelectedLrId(lrDetails[0]?.lr_id);
      setSelectedLrObject(lrDetails[0]);
      getSelectedLrDetails(lrDetails[0]?.lr_id, lrDetails[0]);
    }
  };

  const handleLrPageChange = (page) => {
    setLrPage(page);
  };

  return (
    <Box>
      <Card sx={vlcComponentStyle.card}>
        <CardHeader
          sx={vlcComponentStyle.cardHeader}
          title={
            <LrAsAnchorLegalRequirementCardHeader
              setCardOpen={setCardOpen}
              getLRListForSelectedChapter={getLRListForSelectedChapter}
              lrPage={lrPage}
              lrRowsPerPage={lrRowsPerPage}
              selectedLrObject={selectedLrObject}
            />
          }
        />
        <CardContent
          sx={{
            ...vlcCardStyles.CardContent,
            height: contentHeight || "18rem",
            overflowY: "auto",
            p: 0,
            scrollbarColor: "#888 #f1f1f1",
            scrollbarWidth: "thin",
            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-track": {
              background: "#f1f1f1",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#888",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              background: "#555",
            },
          }}
        >
          {lrList && lrList?.length > 0 ? (
            lrList.map((lrData, index) => {
              console.log("LrData:", lrData);

              return (
                <VlcCardContent
                  onClick={(selectedData) => {
                    setSelectedLrObject(selectedData);
                    setSelectedLrId(selectedData?.lr_id);
                    getSelectedLrDetails(selectedData?.lr_id, selectedData);
                  }}
                  data={lrData}
                  key={lrData?.lr_id || index}
                  isSelected={selectedLrId === lrData?.lr_id}
                  //   cardStyle={cardStyleProp(item)}
                >
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "start",
                      position: "relative",
                      backgroundColor:
                        selectedLrId === lrData?.lr_id ? "#f0f0f0" : "#fff",
                      cursor: "pointer",
                    }}
                  >
                    <Box
                      sx={{
                        // width: width ? width : "75%",
                        width: "100%",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",

                          p: 1,
                        }}
                      >
                        {lrData?.cardDataArray.map(
                          (cardData) => (
                            <Typography
                              key={cardData.key}
                              sx={{
                                ...componentStyle.font.text,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                maxWidth: "100%",
                                display: "flex",
                                gap: 0.5,
                                ...cardData.style,
                              }}
                            >
                              <Box
                                sx={{
                                  ...cardData.keyStyle,
                                }}
                              >{`${cardData.key}:`}</Box>{" "}
                              <Box
                                sx={{
                                  ...cardData.valueStyle,
                                }}
                              >
                                <CustomToolTip
                                  length={40}
                                  style={{ ...cardData.valueStyle }}
                                >
                                  {cardData.value}
                                </CustomToolTip>
                              </Box>
                            </Typography>
                          ),
                        )}
                      </Box>
                    </Box>
                  </Box>
                </VlcCardContent>
              );
            })
          ) : (
            <Typography
              variant="body1"
              sx={{
                textAlign: "center",
                mt: { xs: 1, sm: 2 },
                fontSize: { xs: "0.9rem", sm: "1rem" },
              }}
            >
              No data available
            </Typography>
          )}
        </CardContent>
        <CustomPaginationV2
          page={lrPage}
          rowsPerPage={lrRowsPerPage}
          onPageChange={handleLrPageChange}
          totalItems={lrTotalCount}
        />
      </Card>
    </Box>
  );
}

LrAsAnchorLegalRequirementCardTemplate.propTypes = {
  setCardOpen: PropTypes.func.isRequired,
  contentHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  getSelectedLrDetails: PropTypes.func.isRequired,
};

LrAsAnchorLegalRequirementCardTemplate.defaultProps = {
  contentHeight: "18rem",
};

export default LrAsAnchorLegalRequirementCardTemplate;
